import { environment } from '../../environments/environment';

export const EndpointList = {
  apartments: (id?: number) => composeUri(['apartments', ...(id !== undefined ? [id] : [])]),
  apartmentsCheckAvailability: (id: number) => composeUri(['apartments', id, 'check-availability']),
  apartmentsInitializeReservation: (id: number) => composeUri(['apartments', id, 'initialize-reservation']),
  apartmentsEventsStatusUpdates: () => composeUri(['apartments-events', 'status-updates']),

  paymentsSessionDetails: (sessionId: string) => composeUri(['payments', 'session', sessionId]),
  paymentsCreateIntent: () => composeUri(['payments', 'create-intent']),
  paymentsCreateCheckoutSession: () => composeUri(['payments', 'create-checkout-session']),
  paymentsVerifyCheckoutSession: () => composeUri(['payments', 'verify-checkout-session']),
  paymentsVerify: () => composeUri(['payments', 'verify']),
  paymentsRetry: (reservationId: number) => composeUri(['payments', reservationId, 'retry']),
  paymentsCancel: (reservationId: number) => composeUri(['payments', reservationId, 'cancel']),

  reservationsDetails: (id: number) => composeUri(['reservations', id, 'details']),
  reservations: (id?: number) => composeUri(['reservations', ...(id !== undefined ? [id] : [])]),
  reservationsCancel: (id: number) => composeUri(['reservations', id, 'cancel']),
  reservationsConfirm: (id: number) => composeUri(['reservations', id, 'confirm']),
  reservationsIntent: (id?: number) => composeUri(['reservations', 'intent', id]),
  reservationsIntentValidate: (id: number) => composeUri(['reservations', 'intent', id, 'validate']),
  reservationsIntentComplete: (id: number) => composeUri(['reservations', 'intent', id, 'complete']),

  residentialComplexes: (id?: number) => composeUri(['residential-complexes', ...(id !== undefined ? [id] : [])]),
  residentialComplexesAdmin: (id?: number) => composeUri(['residential-complexes-admin', ...(id !== undefined ? [id] : [])]),
  uploadComplexImage: (id: number) => composeUri(['residential-complexes-admin', id, 'upload-image']),
  residentialComplexesAdminImagesOrder: (id: number) => composeUri(['residential-complexes-admin', id, 'update-images-order']),
  residentialComplexesAdminDeleteImage: (id: number, imageId: number) => composeUri(['residential-complexes-admin', id, 'images', imageId]),
  
  stats: (id?: number) => composeUri(['stats']),
  statsAdmin: (id?: number) => composeUri(['admin', 'stats']),

  login: () => composeUri(['auth', 'login']),
  logout: () => composeUri(['auth', 'logout']),
  me: () => composeUri(['users', 'me']),
  meDelete: () => composeUri(['users', 'me', 'delete']),
  users: (id?: number) => composeUri(['users', id]),
  usersSearch: () => composeUri(['users', 'search']),
  userProfile: () => composeUri(['user', 'profile']),
  forgotPassword: () => composeUri(['auth', 'reset-password']),
  resetPassword: (token: any) => composeUri(['auth', 'reset-password', token]),
  resetPasswordConfirm: () => composeUri(['auth', 'reset-password', 'confirm']),

  apartmentsImportPreview: () => composeUri(['apartments', 'import', 'preview']),
  apartmentsImportProcess: () => composeUri(['apartments', 'import', 'process']),
  apartmentsImportTemplateFields: () => composeUri(['apartments', 'import', 'template-fields']),
  apartmentsImportMapping: (id?: number) => composeUri(['apartments', 'import', 'mapping', ...(id !== undefined ? [id] : [])]),

  // Admin apartment endpoints
  apartmentsAdmin: (id?: number) => composeUri(['admin', 'apartments', ...(id !== undefined ? [id] : [])]),
  apartmentsAdminByComplex: (complexId: number) => composeUri(['admin', 'apartments', 'by-complex', complexId]),
  apartmentsAdminByComplexAll: (complexId: number) => composeUri(['admin', 'apartments', 'by-complex', complexId, 'all']),
  apartmentsAdminStatus: (id: number) => composeUri(['admin', 'apartments', id, 'status']),
};

function composeUri(values: (string | number | undefined)[]): string {
  return [
    environment.apiUrl,
    ...values.filter(v => v !== undefined && v !== null && v !== ''),
  ].join('/');
}